import { render, staticRenderFns } from "./FabricPermissionIndex.vue?vue&type=template&id=63c62aa3&"
import script from "./FabricPermissionIndex.vue?vue&type=script&lang=js&"
export * from "./FabricPermissionIndex.vue?vue&type=script&lang=js&"
import style0 from "./FabricPermissionIndex.vue?vue&type=style&index=0&id=63c62aa3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports